import React, { useState } from 'react';
import './UpdateCredentialsModal.css';

// Shown once per browser, on the first signed-in visit: the web is the companion, the phone is Udal.
// 2026-10-28.
//
// Not the phone's "How Udal works" slides: two of the three describe what only the phone does —
// noticing a park by itself, and sharing the spot on the way back — and the web has no Request or
// "I'm leaving" either (removed 2026-10-17: a laptop cannot drive to a spot). Shown here, those slides
// would promise features this page does not have. So it says one thing: get the app.
//
// The store buttons appear once their links are set below — leave them null until the apps are
// published; until then the card says "install Udal on your phone" without them.
const APP_STORE_URL = null; // e.g. 'https://apps.apple.com/app/id…'
const PLAY_STORE_URL = null; // e.g. 'https://play.google.com/store/apps/details?id=com.udalapp.udal'

export const APP_PROMO_SEEN_KEY = 'appPromoSeen';

export function appPromoAlreadySeen() {
  try { return localStorage.getItem(APP_PROMO_SEEN_KEY) === '1'; } catch (_) { return true; } // no storage: do not nag
}

const storeLink = { display: 'inline-block', padding: '10px 16px', borderRadius: 999, background: '#1c1c1e', color: '#fff', fontWeight: 600, textDecoration: 'none', fontSize: '0.92rem' };

const AppPromoCard = ({ onClose }) => {
  const [closing, setClosing] = useState(false);
  const close = () => {
    try { localStorage.setItem(APP_PROMO_SEEN_KEY, '1'); } catch (_) { /* shown again next time: harmless */ }
    setClosing(true);
    onClose?.();
  };
  if (closing) return null;
  const hasStores = !!(APP_STORE_URL || PLAY_STORE_URL);
  return (
    <div className="update-credentials-modal-overlay" onClick={close}>
      <div className="update-credentials-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 420, textAlign: 'center' }}>
        <div style={{ fontSize: 40, lineHeight: 1, margin: '6px 0 10px' }} aria-hidden="true">📱</div>
        <h2 style={{ margin: '0 0 10px' }}>Udal works best on your phone</h2>
        <p style={{ margin: '0 0 14px', lineHeight: 1.5 }}>
          It notices when you park, keeps your car on the map, and shares your space when you leave —
          all by itself. The website is for checking the map, your messages and your profile.
        </p>
        {hasStores ? (
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 14 }}>
            {APP_STORE_URL && <a href={APP_STORE_URL} target="_blank" rel="noreferrer" style={storeLink}>App Store</a>}
            {PLAY_STORE_URL && <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer" style={storeLink}>Google Play</a>}
          </div>
        ) : (
          <p style={{ margin: '0 0 14px', fontWeight: 600 }}>Install Udal on your phone to get started.</p>
        )}
        <div className="btn-row" style={{ justifyContent: 'center' }}>
          <button type="button" className="btn btn--primary" onClick={close}>Got it</button>
        </div>
      </div>
    </div>
  );
};

export default AppPromoCard;
